export const module = {
  info: {
    name: 'jikatel-customer',
    caption: 'Jikatel Customer'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel Customer',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-customer',
    children: [
      {
        caption: 'Create Customer',
        icon: 'el-icon-plus',
        routeName: 'module->jikatel-customer->create'
      },
      {
        caption: 'List Customers',
        icon: 'el-icon-more-outline',
        routeName: 'module->jikatel-customer->list'
      }
    ]
  }
}

export default module
